export class PropertyExpenseDTO{
    public id?:number;
    public propertyId!:number;
    public description!:string;
    public amount!:number;
    public userId?:string;
    public userName?:string;
    public userFirstName?:string;
    public userLastName?:string;
    public added?:string;
    public edited?:string;
}